import { useSaveCollectionColoursModalStore } from "../../../js/stores/save-collection-colours-modal-store";
import { Dialog, DialogContent } from "../shared/modal";
import { SaveCollectionColoursContent } from "./save-collection-colours-content";

function SaveCollectionColoursDialog({ isModalOpen, updateIsModalOpen }) {
  return (
    <Dialog
      open={isModalOpen}
      onClose={() => updateIsModalOpen(false)}
      onOpenChange={updateIsModalOpen}
    >
      <DialogContent className="save-colours-modal">
        <SaveCollectionColoursContent closeClickHandler={() => updateIsModalOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}

export function SaveCollectionColoursModal() {
  const isModalOpen = useSaveCollectionColoursModalStore((state) => state.isModalOpen);
  const updateIsModalOpen = useSaveCollectionColoursModalStore(
    (state) => state.updateIsModalOpen
  );

  return (
    <>
      {isModalOpen && (
        // Remounted per open, as every other modal here is, so the selection and any error from
        // the previous collection do not bleed into the next one.
        <SaveCollectionColoursDialog
          key={crypto?.randomUUID()}
          isModalOpen={isModalOpen}
          updateIsModalOpen={updateIsModalOpen}
        />
      )}
    </>
  );
}
